import {Fetch} from "./Fetch";

export class ReportAPI {

    static   getReport(id){
        return Fetch('GET', `api/calculator/report/${id}`);
        // return data;
    }

    static async getHomeReport(id){
        let data = await Fetch('GET', `api/calculator/get_home_report`);
        return data;
    }

    static async getLightReport(id){
        let data = await Fetch('GET', `api/calculator/light_report/${id}`);
        return data;
    }

    static async listReports(){
        let reports = await Fetch('GET', 'api/calculator/report/list');
        return reports;
    }

    static async listPDFReports(){
        let reports = await Fetch('GET', 'api/calculator/report/pdf_reports');
        return reports;
    }

    static async isReady(id){
        let resp = await Fetch('GET', 'api/calculator/report_polling/'+id);
        return resp.ready === true;
    }

    static async getPreSignedUrl(id){
        let resp = await Fetch('GET', 'api/calculator/download/'+id);
        return resp.url;
    }

    static async statistics(){
        let resp = await Fetch('GET', 'api/calculator/report/statistics');
        return resp;
    }

    static async submitLightReport(countryId, industryId, label){
        let result = await Fetch('POST', 'api/calculator/light_report',{
            country_id: countryId,
            industry_id: industryId,
            label,
        });
        return result;
    }

    static async invite(email, reportId, isInvestor) {
        let result = await Fetch('POST', 'api/calculator/report/share/', {
            "email": email,
            "report": reportId,
            "is_investor": isInvestor
        });
        return result;
    }

    static async listSharedReports(email, reportId, isInvestor) {
        let result = await Fetch('GET', 'api/calculator/report/share/');
        return result;
    }

    static async listSharedReportUser(reportId) {
        let result = await Fetch('GET', `api/calculator/report/shared_with/${reportId}`);
        return result;
    }

    static async generateShareURL(reportId) {
        let result = await Fetch('GET', `api/calculator/report/share_url/${reportId}`);
        return result;
    }
}
